import { format } from 'date-fns';

import { utcStartOfDay } from '@paradigm/utils/src/date';

import { DraftLeg } from '#/unified-rfqs/ui/rfq-builder/types';
import { UnifiedInstruments } from '#/unified-rfqs/ui/instruments/types';
import { areExpirationsEqual } from './expiration-utils';

export function futureExpirationView(
  expiration: DraftLeg['expiration'],
  instruments: UnifiedInstruments['futureInstruments'],
) {
  const sortedInstruments = sortInstruments(instruments);

  const options = sortedInstruments.map((instrument) => ({
    value: instrument.expiration,
    label: formatExpiration(instrument.expiration),
  }));

  const selectedOption =
    options.find((option) => areExpirationsEqual(expiration, option.value)) ??
    null;

  return { options, selectedOption, isValid: selectedOption !== null };
}

function formatExpiration(expiration: number | null) {
  if (expiration === null) return 'Perpetual';
  const date = utcStartOfDay(new Date(expiration));
  return format(date, 'dd MMM yy');
}

/**
 * Sort instruments so that ones with perpetual (`null`) expiration
 * come first and the rest is ordered by ascending expiration .
 */
function sortInstruments(instruments: UnifiedInstruments['futureInstruments']) {
  return [...instruments].sort((a, b) => {
    if (a.expiration === null) return -1;
    if (b.expiration === null) return 1;
    return a.expiration - b.expiration;
  });
}
